module.exports = __webpack_public_path__ + "static/media/icici_fund.8d188155.svg";